import '../App.css';
import React, { useState } from 'react';
import NuvoApp from './NuvoApp';
import { Link } from 'react-router-dom';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { PAGES } from '../constants/Pages';
import { MESSAGE } from '../constants/Message';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { getMessage } from '../translations';
import TextField from '@mui/material/TextField';

function LoadingScreen() {
  const [showUnitSelectionPopup, setShowUnitSelectionPopup] = useState(false);
  const [userUnitData, setUserUnitData] = useState('');
  const [deviationType, setDeviationType] = useState('');
  const [loadingType, setLoadingType] = useState('');
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const navigate = useNavigate();
  const handleGoButtonClick = (e) => {
    e.preventDefault();
    if (!userUnitData || !loadingType) {
      setShowValidationMessage(true);
    } else {
      window.location.href = `/${PAGES.LOADINGAPP}/${userUnitData}&${loadingType}&${deviationType}`;
    }
  };

  return (
    <>
      <body>
        <Header />
        <section id='deliveries-section' className='active'>
          <div id='container12' className='container columns full screen'>
            <div className='wrapper'>
              <div
                className='main-inner'
                data-onvisible-trigger='1'
                data-reorder='1,0'
                data-reorder-breakpoint='medium'
                style={{ opacity: 1 }}
              >
                <div className='w-50'>
                  <div className='container12info'>
                    <h2 id='text29' className='style8'>
                      <span className='p'>{getMessage('LOADING_IMPORT')}</span>
                    </h2>
                    <ul
                      id='buttons24'
                      className='style1 buttons'
                      style={{ opacity: 1 }}
                    >
                      <li>
                        <button
                          className='QuantityAddBtn button n01'
                          onClick={() => {
                            setShowUnitSelectionPopup(true);
                          }}
                        >
                          <RiArrowDropRightLine className='startIcon' />{' '}
                          {getMessage('START_IMPORT')}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='w-40'>
                  <div id='image06' className='image full'>
                    <span className='frame deferred'>
                      <img
                        src='https://julesai.com/assets/images/image06.png'
                        data-src='done'
                        alt=''
                        style={{ opacity: 1 }}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </body>
      {showUnitSelectionPopup ? (
        <div className='overlay-box'>
          <div className='popup'>
            <a
              className='close'
              onClick={() => {
                setShowUnitSelectionPopup(false);
              }}
            >
              <svg
                className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                focusable='false'
                viewBox='0 0 24 24'
                aria-hidden='true'
                data-testid='CloseIcon'
              >
                <path
                  d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                ></path>
              </svg>
            </a>
            <div className='content'>
              <form id='simpleForm'>
                <div className='AddCategoryBody loadingSelection'>
                  <h4>{getMessage('LOADING_UNIT')}</h4>
                  <>
                    <FormControl
                      className='FormField'
                      sx={{ m: 1, minWidth: '47%' }}
                    >
                      <Select
                        value={userUnitData}
                        onChange={(e) => setUserUnitData(e.target.value)}
                        required
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={''}>
                          {getMessage('VOLUME_UNIT')}
                        </MenuItem>
                        <MenuItem value={'Kg'}>Kg</MenuItem>
                        <MenuItem value={'T'}>T</MenuItem>
                        <MenuItem value={'Lbs'}>Lbs</MenuItem>
                        <MenuItem value={'ST'}>ST</MenuItem>
                        <MenuItem value={'GT'}>GT</MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl
                      className='FormField'
                      sx={{ m: 1, minWidth: '47%' }}
                    >
                      <Select
                        value={loadingType}
                        onChange={(e) => setLoadingType(e.target.value)}
                        required
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={''}>
                          {getMessage('LOADING_TYPE')}
                        </MenuItem>
                        <MenuItem value={'MATERIAL'}>
                          {getMessage('MATERIAL')}
                        </MenuItem>
                        <MenuItem value={'ITEM'}>{getMessage('ITEM')}</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      className='FormField'
                      sx={{ m: 1, minWidth: '47%' }}
                    >
                      <Select
                        value={deviationType}
                        onChange={(e) => setDeviationType(e.target.value)}
                        required
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={''}>
                          {getMessage('Select deviation type')}
                        </MenuItem>
                        <MenuItem value={'Sterile'}>Sterile</MenuItem>
                      </Select>
                    </FormControl>
                    <div className='validationMsg'>
                      {showValidationMessage &&
                        (!userUnitData || !loadingType ) && (
                        <p className='errorMsg'>
                          {MESSAGE.ENG.POPUP_LOADING_VALIDATION}
                        </p>
                      )}
                    </div>

                    <div className='btnSection'>
                      <Button variant='contained' onClick={handleGoButtonClick}>
                        {getMessage('GO')}
                      </Button>
                    </div>
                  </>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default LoadingScreen;